import React from 'react';

// eslint-disable-next-line import/no-dynamic-require
const { gatsbyConfig } = require(`@powdr/${process.env.GATSBY_PROPERTY_NAME}`);

export const InntopiaTracking = () => {
  const inntopiaID = gatsbyConfig?.inntopiaAccountID;

  if (!inntopiaID) return null;

  // Because this is being used in a frontend component and
  // not SEO, dangerouslySetInnerHTML is used to prevent
  // React from improperly escaping/invalidating the script
  const snippet = `
    (function(e,t,o,n,p,r,i){e.visitorGlobalObjectAlias=n;e[e.visitorGlobalObjectAlias]=e[e.visitorGlobalObjectAlias]||function(){(e[e.visitorGlobalObjectAlias].q=e[e.visitorGlobalObjectAlias].q||[]).push(arguments)};e[e.visitorGlobalObjectAlias].l=(new Date).getTime();r=t.createElement("script");r.src=o;r.async=true;i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(r,i)})(window,document,"https://diffuser-cdn.app-us1.com/diffuser/diffuser.js","vgo");
    vgo('setAccount', '${inntopiaID}');
    vgo('setTrackByDefault', true);
    vgo('process');
  `;

  return <script dangerouslySetInnerHTML={{ __html: snippet }} />;
};

InntopiaTracking.propTypes = {};
